import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

import { messages } from '../messages';

const Country = ({ fulfillmentId }) => {
  const fulfillment = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId }));

  const { fulfillmentPlanId } = fulfillment;

  const fulfillmentPlan = useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId })) || {};

  const { salesOrdersFulfilledIds } = fulfillmentPlan;

  const [salesOrderId] = salesOrdersFulfilledIds ?? [];

  const [shipTo] =
    useSelector((state) =>
      Global.selectEntitiesSalesOrderProperty(state, {
        salesOrderId,
        property: 'shipTos',
      }),
    ) ?? [];

  return shipTo?.countryCode ?? '';
};

Country.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const country = {
  getMessageDescriptor: () => messages.country,
  name: <FormattedMessage {...messages.country} />,
  id: 'country',
  render: (data) => <Country fulfillmentId={data.id} />,
};
